import Dropdown from '@ubnt/ui-components/Dropdown/Dropdown';
import { DropdownOption, DropdownValue } from '@ubnt/ui-components/Dropdown/types';
import { range } from 'lodash-es';
import { memo, useCallback, useMemo } from 'react';

interface ChainCountDropdownProps {
  disabled?: boolean;
  onChange: (newValue: number) => void;
  maxChainCount: number;
  value: number;
}

const ChainCountDropdownImpl = (props: ChainCountDropdownProps) => {
  const { disabled, maxChainCount, value, onChange: onChangeProp } = props;

  const options = useMemo(() => {
    return range(1, maxChainCount + 1).map((chainCount) => ({
      label: `${chainCount}x${chainCount}`,
      value: chainCount,
    }));
  }, [maxChainCount]);

  const onChange = useCallback(
    (_: DropdownOption, newValue: DropdownValue) => {
      onChangeProp(Number(newValue));
    },
    [onChangeProp]
  );

  return (
    <Dropdown
      disabled={disabled}
      label="MIMO"
      onChange={onChange}
      options={options}
      value={value}
      variant="secondary"
      width="106px"
    />
  );
};

const ChainCountDropdown = memo(ChainCountDropdownImpl);

export default ChainCountDropdown;
